
<div class="my-layout-inner">
  <div class="my-layout-inner-header">
    <div class="my-header my-layout-header">
      <div class="my-header-image-wrapper"><div></div></div>
    </div>
  </div>
  <div class="my-layout-inner-body">
    <div class="my-body-layout-wrapper">
      <mat-card appearance="outlined" class="my-card my-card-stripped my-card-external">
        <mat-card-content>
          <!-- Check maintenance active ; else errorTpl-->
          @if (isMaintenanceActive$ | async; as isMaintenanceActive) {
            <section class="my-text-section">
              <h2>Maintenance en cours</h2>
              <p>myMillennium est en maintenance pour le moment. Veuillez nous excuser pour ce désagrément.</p><br>
            </section>
          } @else {
            @if (!isMaintenanceChecking) {
              <section class="my-text-section">
                <h2>Une erreur est survenue</h2>
                <p>myMillennium semble inutilisable pour le moment. Veuillez nous excuser pour ce désagrément.</p><br>
              </section>
            } @else {
              <section class="my-text-section">
                <h2><app-loader-text text="Vérification en cours"></app-loader-text></h2><br>
              </section>
            }
          }

          <!-- Retry -->
          @if (!isMaintenanceChecking) {
            <p>Vous pouvez <span class="my-link" (click)="onReload()">réessayer</span> plus tard.</p>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>


